import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faFileArrowDown, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import CreatePdfClasse from 'components/CreatePdfClasse';
import { generateEvaluationPdf } from '../utils/evaluationPdf';

import axios from 'axios';
import { NotificationManager } from 'react-notifications';

import { useSelector } from 'react-redux'
import { getPageCount } from '../utils/pagination';

export default function ClasseNoteCardEval({idClasse, positionEleve, suivi}) {
    const [cycleSelected, setCycleSelected] = useState('0');
    const [competenceSelected, setCompetenceSelected] = useState({'id_competence': 0});
    const [sequenceSelected, setSequenceSelected] = useState({'id_sequence': 0});
    const [categorieSelected, setCategorieSelected] = useState({'id_categorie': 0});

    const [listeCompetence, setListeCompetence] = useState([]);
    const [listeSequence, setListeSequence] = useState([]);
    const [listeCategorie, setListeCategorie] = useState([]);
    const [allNoteSeance, setAllNoteSeance] = useState([]);
    const [availableEvaluations, setAvailableEvaluations] = useState([]);
    const [availabilityStatus, setAvailabilityStatus] = useState('loading');
    const [isLoadingExport, setIsLoadingExport] = useState(false);
    const [pdfReportData, setPdfReportData] = useState(null);
    const [exportingPage, setExportingPage] = useState(null);
    const loadRequestRef = React.useRef(0);

    const user_abo = useSelector(state => state.userAbo.user)

    const sameId = (left, right) => String(left) === String(right);

    React.useEffect(() => {
        let isMounted = true;
        loadRequestRef.current += 1;
        setAvailabilityStatus('loading');
        setAvailableEvaluations([]);
        setCycleSelected('0');
        setCompetenceSelected({'id_competence': 0});
        setSequenceSelected({'id_sequence': 0});
        setCategorieSelected({'id_categorie': 0});
        setListeCompetence([]);
        setListeSequence([]);
        setListeCategorie([]);
        setAllNoteSeance([]);
        setPdfReportData(null);

        async function loadAvailableEvaluations() {
            try {
                const [notesResponse, cyclesResponse] = await Promise.all([
                    axios.get(`https://eps.acces-editions.com/api/getNoteSceance?id_classe=${idClasse}`),
                    axios.get('https://eps.acces-editions.com/api/getCycle'),
                ]);
                const evaluatedSessions = Array.isArray(notesResponse.data) ? notesResponse.data : [];
                const cycles = Array.isArray(cyclesResponse.data?.listeCycle) ? cyclesResponse.data.listeCycle : [];
                const competenceResponses = await Promise.all(cycles.map((cycle) => (
                    axios.get(`https://eps.acces-editions.com/api/getCompetence?id_cycle=${cycle.id_cycle}`)
                )));
                const competenceCycles = new Map();
                competenceResponses.forEach((response, index) => {
                    const competences = Array.isArray(response.data?.listeCompetence) ? response.data.listeCompetence : [];
                    competences.forEach((competence) => {
                        competenceCycles.set(String(competence.id_competence), cycles[index].id_cycle);
                    });
                });

                const details = await Promise.all(evaluatedSessions.map(async (row) => {
                    try {
                        const detailResponse = await axios.get(`https://eps.acces-editions.com/api/getSeanceById?id=${row.id_seance}`);
                        const detail = detailResponse.data?.seance?.[0];
                        const hierarchyCycle = detail && competenceCycles.get(String(detail.id_competence));
                        if (!detail || hierarchyCycle === undefined) return null;

                        return {
                            id_seance: row.id_seance,
                            id_cycle: hierarchyCycle,
                            id_competence: detail.id_competence,
                            id_sequence: detail.id_sequences,
                            id_categorie: detail.id_categorie,
                        };
                    } catch (error) {
                        return null;
                    }
                }));

                if (isMounted) {
                    setAvailableEvaluations(details.filter(Boolean));
                    setAvailabilityStatus('ready');
                }
            } catch (error) {
                if (isMounted) setAvailabilityStatus('error');
            }
        }

        loadAvailableEvaluations();
        return () => {
            isMounted = false;
        };
    }, [idClasse]);

    const loadSessionDetails = async (evaluations) => {
        const requestId = ++loadRequestRef.current;
        const uniqueEvaluations = evaluations.filter((row, index, rows) => (
            rows.findIndex((candidate) => sameId(candidate.id_seance, row.id_seance)) === index
        ));

        setAllNoteSeance([]);
        setPdfReportData(null);
        setIsLoadingExport(true);

        try {
            const details = await Promise.all(uniqueEvaluations.map(async (row) => {
                const response = await axios.get(`https://eps.acces-editions.com/api/getDetailSeance?id=${row.id_seance}`);
                return response.data?.detailSeance?.[0] || null;
            }));

            if (loadRequestRef.current === requestId) setAllNoteSeance(details.filter(Boolean));
        } catch (error) {
            if (loadRequestRef.current === requestId) setAllNoteSeance([]);
        } finally {
            if (loadRequestRef.current === requestId) setIsLoadingExport(false);
        }
    };

    async function generatePDF(i) {
        if (!pdfReportData || exportingPage !== null) return;

        setExportingPage(String(i));
        try {
            await generateEvaluationPdf({
                idClasse,
                reportData: pdfReportData,
                activityPageIndex: Number(i) - 1,
                cycleSelected,
                competenceSelected,
                sequenceSelected,
                categorieSelected,
            });
        } catch (error) {
            NotificationManager.error("Le PDF n'a pas pu être généré", '', 3000);
        } finally {
            setExportingPage(null);
        }
    }

    const ButtonExport = ({allNoteSeance}) => {
        const nbPage = getPageCount(allNoteSeance.length, 6)

        var content = []

        for (var i = 1; i <= nbPage; i++) {
            content.push(
                <button key={"btnExport_" + i} id={"btnExport_" + i} disabled={!pdfReportData || exportingPage !== null} onClick={(e) => {e.preventDefault(); generatePDF(e.currentTarget.value)}} className="ae-workspace-primary-button" type="button" value={i}>
                    <FontAwesomeIcon icon={faFileArrowDown} />
                    <span>{exportingPage === String(i) ? 'Génération…' : !pdfReportData ? 'Préparation…' : "Export PDF " + i + "/" + nbPage}</span>
                </button>
            )
        }

        return(content)
    }

    const selectCycle = (value) => {
        loadRequestRef.current += 1
        setIsLoadingExport(false)
        setCycleSelected(value)
        setCompetenceSelected({'id_competence': 0})
        setSequenceSelected({'id_sequence': 0})
        setCategorieSelected({'id_categorie': 0})
        setListeCompetence([])
        setListeSequence([])
        setListeCategorie([])
        setAllNoteSeance([])
        if (value === '0') return;

        const availableCompetenceIds = new Set(availableEvaluations
            .filter((row) => sameId(row.id_cycle, value))
            .map((row) => String(row.id_competence)));

        axios.get('https://eps.acces-editions.com/api/getCompetence?id_cycle='+value)
        .then((res) => {
            if(res.data.listeCompetence[0] !== undefined)
            {
                setListeCompetence(res.data.listeCompetence.filter((row) => availableCompetenceIds.has(String(row.id_competence))))
            } else {
                setListeCompetence([])
            }
        }).catch(() => setListeCompetence([]))
    }

    const selectCompetence = (value) => {
        loadRequestRef.current += 1
        setIsLoadingExport(false)
        if (value === '0') {
            setCompetenceSelected({'id_competence': 0})
            setSequenceSelected({'id_sequence': 0})
            setCategorieSelected({'id_categorie': 0})
            setListeSequence([])
            setListeCategorie([])
            setAllNoteSeance([])
            return;
        }

        value = JSON.parse(value)
        setCompetenceSelected(value)
        setSequenceSelected({'id_sequence': 0})
        setCategorieSelected({'id_categorie': 0})
        setListeSequence([])
        setListeCategorie([])
        setAllNoteSeance([])

        const availableSequenceIds = new Set(availableEvaluations
            .filter((row) => sameId(row.id_cycle, cycleSelected) && sameId(row.id_competence, value.id_competence))
            .map((row) => String(row.id_sequence)));

        axios.get('https://eps.acces-editions.com/api/getSequence?id_competence='+value.id_competence)
        .then((res) => {
            if(res.data.listeSequence[0] !== undefined)
            {
                setListeSequence(res.data.listeSequence.filter((row) => availableSequenceIds.has(String(row.id_sequence))))
            } else {
                setListeSequence([])
            }
        }).catch(() => setListeSequence([]))
    }

    const selectSequence = (value) => {
        loadRequestRef.current += 1
        setIsLoadingExport(false)
        if (value === '0') {
            setSequenceSelected({'id_sequence': 0})
            setCategorieSelected({'id_categorie': 0})
            setListeCategorie([])
            setAllNoteSeance([])
            return;
        }

        value = JSON.parse(value)
        setSequenceSelected(value)
        setCategorieSelected({'id_categorie': 0})
        setListeCategorie([])
        setAllNoteSeance([])

        const exportableEvaluations = availableEvaluations.filter((row) => (
            sameId(row.id_cycle, cycleSelected)
            && sameId(row.id_competence, competenceSelected.id_competence)
            && sameId(row.id_sequence, value.id_sequence)
        ));
        const availableCategoryIds = new Set(exportableEvaluations.map((row) => String(row.id_categorie)));

        axios.get('https://eps.acces-editions.com/api/getCategorie?id_sequence='+value.id_sequence)
        .then((res) => {
            const categories = Array.isArray(res.data.listeCategorie)
                ? res.data.listeCategorie.filter((row) => availableCategoryIds.has(String(row.id_categorie)))
                : [];

            if(categories.length > 0)
            {
                setListeCategorie(categories)
            } else {
                setListeCategorie([])
                setCategorieSelected({'id_categorie': 'all', nom: 'Toutes les activités', url_img: 'nat1'})
                loadSessionDetails(exportableEvaluations)
            }
        }).catch(() => {
            setListeCategorie([])
            setCategorieSelected({'id_categorie': 'all', nom: 'Toutes les activités', url_img: 'nat1'})
            loadSessionDetails(exportableEvaluations)
        })
    }

    const selectCategorie = (value) => {
        loadRequestRef.current += 1
        setIsLoadingExport(false)
        if (value === '0') {
            setCategorieSelected({'id_categorie': 0})
            setAllNoteSeance([])
            return;
        }

        value = JSON.parse(value)
        setCategorieSelected(value)
        const exportableEvaluations = availableEvaluations.filter((row) => (
            sameId(row.id_cycle, cycleSelected)
            && sameId(row.id_competence, competenceSelected.id_competence)
            && sameId(row.id_sequence, sequenceSelected.id_sequence)
            && (value.id_categorie === 'all' || sameId(row.id_categorie, value.id_categorie))
        ));
        loadSessionDetails(exportableEvaluations)
    }

    const availableCycleIds = new Set(availableEvaluations.map((row) => String(row.id_cycle)));

    return (
        <section className="ae-workspace-card">
            <header className="ae-workspace-card-header">
                <span className="ae-workspace-card-icon"><FontAwesomeIcon icon={faFilePdf} /></span>
                <div>
                    <h2>Exporter le suivi des évaluations</h2>
                    <p>Seules les combinaisons contenant des évaluations exportables sont proposées.</p>
                </div>
            </header>

            <div className="ae-workspace-card-body">
                <div className="ae-workspace-filter-grid">
                    <div className="ae-workspace-field">
                        <label htmlFor="evaluation-cycle">Cycle</label>
                        <select id="evaluation-cycle" value={cycleSelected} disabled={availabilityStatus !== 'ready'} onChange={(e) => selectCycle(e.target.value)}>
                            <option value="0">{availabilityStatus === 'loading' ? 'Recherche des évaluations…' : 'Choisir un cycle'}</option>
                            {user_abo?.cycle_3 === 1 && availableCycleIds.has('3') && <option value="3">Cycle 3</option>}
                            {user_abo?.cycle_2 === 1 && availableCycleIds.has('2') && <option value="2">Cycle 2</option>}
                            {user_abo?.cycle_1 === 1 && availableCycleIds.has('1') && <option value="1">Cycle 1</option>}
                        </select>
                    </div>

                    <div className={`ae-workspace-field${cycleSelected === '0' ? ' ae-workspace-field--disabled' : ''}`}>
                        <label htmlFor="evaluation-competence">Compétence</label>
                        <select id="evaluation-competence" value={competenceSelected.id_competence === 0 ? '0' : JSON.stringify(competenceSelected)} disabled={cycleSelected === '0'} onChange={(e) => selectCompetence(e.target.value)}>
                            <option value="0">Choisir une compétence</option>
                            {listeCompetence.map((row) => <option key={row.id_competence} value={JSON.stringify(row)}>{row.nom}</option>)}
                        </select>
                    </div>

                    <div className={`ae-workspace-field${competenceSelected.id_competence === 0 ? ' ae-workspace-field--disabled' : ''}`}>
                        <label htmlFor="evaluation-sequence">Séquence</label>
                        <select id="evaluation-sequence" value={sequenceSelected.id_sequence === 0 ? '0' : JSON.stringify(sequenceSelected)} disabled={competenceSelected.id_competence === 0} onChange={(e) => selectSequence(e.target.value)}>
                            <option value="0">Choisir une séquence</option>
                            {listeSequence.map((row) => <option key={row.id_sequence} value={JSON.stringify(row)}>{row.nom}</option>)}
                        </select>
                    </div>

                    <div className={`ae-workspace-field${sequenceSelected.id_sequence === 0 || listeCategorie.length === 0 ? ' ae-workspace-field--disabled' : ''}`}>
                        <label htmlFor="evaluation-category">Catégorie</label>
                        <select id="evaluation-category" value={categorieSelected.id_categorie === 0 ? '0' : JSON.stringify(categorieSelected)} disabled={sequenceSelected.id_sequence === 0 || listeCategorie.length === 0} onChange={(e) => selectCategorie(e.target.value)}>
                            <option value="0">Choisir une catégorie</option>
                            {listeCategorie.map((row) => <option key={row.id_categorie} value={JSON.stringify(row)}>{row.nom}</option>)}
                            <option value={JSON.stringify({'id_categorie': 'all', nom: "Toutes les catégories", url_img: 'nat1'})}>Toutes les catégories</option>
                        </select>
                    </div>
                </div>

                {allNoteSeance.length > 0 ? (
                    <div>
                        <CreatePdfClasse idClasse={idClasse} allNoteSeance={allNoteSeance} positionEleve={positionEleve} onReady={setPdfReportData} />
                        <div className="ae-workspace-export-actions"><ButtonExport allNoteSeance={allNoteSeance} /></div>
                    </div>
                ) : (
                    <div className="ae-workspace-feedback">
                        <FontAwesomeIcon icon={faCircleInfo} />
                        <span>
                            {availabilityStatus === 'loading'
                                ? 'Recherche des évaluations disponibles…'
                                : availabilityStatus === 'error'
                                    ? "Les évaluations disponibles n'ont pas pu être chargées."
                                    : availableEvaluations.length === 0
                                        ? 'Aucune évaluation exportable pour cette classe.'
                                        : isLoadingExport
                                            ? 'Préparation du document PDF…'
                                            : 'Sélectionnez les critères proposés pour préparer un export PDF.'}
                        </span>
                    </div>
                )}
            </div>
        </section>
    );
}
